import {
  GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_INVALID,
  GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_LOAD,
  GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALID,
  GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALUE_UPDATE,
  GENERAL_CONTRACTOR_TEAM_INVITE_USER_ID_SET,
  GENERAL_CONTRACTOR_TEAM_INVITE_USER_MODAL_SHOW,
  GENERAL_CONTRACTOR_TEAM_SHOW_VERIFICATION_MODAL,
} from 'actions/admin/team/action-types';
import { UserModalState } from 'components/shared/modal/InviteUserModal';

export const initialState = {
  currentUserId: 0,
  form: {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    rolesId: null,
  },
  invalidFields: [],
  showInviteUserModal: false,
  userModalState: UserModalState.NEW, // one of UserModalState
  validationMessage: '',
  verificationModal: null,
};

export default function generalContractorTeamUiReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_INVALID:
      return {
        ...state,
        invalidFields: action.payload.invalidFields,
        validationMessage: action.payload.message,
      };

    case GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_LOAD:
      return {
        ...state,
        form: action.payload,
        invalidFields: [],
        validationMessage: '',
      };

    case GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALID:
      return {
        ...state,
        invalidFields: [],
        validationMessage: '',
      };

    case GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALUE_UPDATE:
      return {
        ...state,
        form: {
          ...state.form,
          [action.payload.attribute]: action.payload.value,
        },
      };

    case GENERAL_CONTRACTOR_TEAM_INVITE_USER_ID_SET:
      return {
        ...state,
        currentUserId: action.payload,
      };

    case GENERAL_CONTRACTOR_TEAM_INVITE_USER_MODAL_SHOW:
      const newState = {
        ...state,
        showInviteUserModal: action.payload.open,
      };
      if (action.payload.state !== undefined) {
        newState['userModalState'] = action.payload.state;
      }

      return newState;

    case GENERAL_CONTRACTOR_TEAM_SHOW_VERIFICATION_MODAL:
      return {
        ...state,
        verificationModal: action.payload,
      };

    default:
      return state;
  }
}
